var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryToggleMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H16M8.5 5.5L16 5.5M8.5 8.5L16 8.5M1 13L16 13M4.73234 9.56917L1.19702 7.31648C0.93514 7.14961 0.934307 6.78976 1.19552 6.66875L4.72186 5.03506C4.98308 4.91405 5.31042 5.12263 5.31109 5.41051L5.32007 9.29689C5.32073 9.58477 4.99422 9.73604 4.73234 9.56917Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryToggleMobile);
export default __webpack_public_path__ + "static/media/historyToggleMobile.a27b5fb996af07d396c675c7fde3f91e.svg";
export { ForwardRef as ReactComponent };